<figure class="container-logo">
  <img class="container-logo__image" [src]="imagePath" [alt]="altText">
</figure>